import { Validators } from "@angular/forms";
import { BasespaceFormControl, BasespaceFormProperties } from "../bs-app-launch-form-control";
import { BsAppLaunchCheckboxControlComponent } from "./bs-app-launch-checkbox-control.component";
import { isNullOrUndefined } from "util";

interface CheckBoxChoice {
    checked: boolean; 
    label: string; 
    value: any; 
}

export interface CheckboxFormControlProperties extends BasespaceFormProperties<BsAppLaunchCheckboxControlComponent> {
    choices: CheckBoxChoice[];
    togglers: any[];
}

// Reference docs: https://dagobah-developer.cloud-test.illumina.com/docs/content/documentation/apptools/formbuilder-overview#CheckBox
// Reference class: src/Cloud.FormBuilder/Models/CheckBox.cs
export class CheckBoxFormControl extends BasespaceFormControl<BsAppLaunchCheckboxControlComponent> implements CheckboxFormControlProperties {
    choices: CheckBoxChoice[];
    togglers: { toggleOnValue: string | number; toggleFields: string | number } [];

    constructor(
        data: CheckboxFormControlProperties
    ) {
        const { id, componentReference, label, helpText, value, required, requiredMessage, choices, togglers, tabularFieldSetStyling, formControlType } = data;
        super({ id, componentReference, label, helpText, value, required, requiredMessage, tabularFieldSetStyling, formControlType });

        this.choices = choices;
        this.togglers = togglers;
        this.size = 'auto';

        if(required) {
            this.setValidators(Validators.required);
        }
    
        const initialValue = this.choices
            .filter((choice) => !!choice.checked)
            // Value can be number or string
            .map((choice) => choice.value);

        this.setValue(initialValue);
    }

    /**
     * Override setValue to also update the checked state of choices.
     * This ensures the visual state stays in sync when value is programmatically changed.
     */
    setValue(value: any, options?: { onlySelf?: boolean; emitEvent?: boolean; emitModelToViewChange?: boolean; emitViewToModelChange?: boolean }): void {
        value = Array.isArray(value) ? 
            value : 
            isNullOrUndefined(value) ?
            [] :
            [value];
        super.setValue(value, options);
        this.syncChoicesCheckedState(value);
    }

    /**
     * Syncs the checked state of each choice based on the current value array.
     */
    private syncChoicesCheckedState(value: any[] | null): void {
        if (!this.choices) {
            return;
        }

        const selectedValues = value || [];
        this.choices.forEach((choice) => {
            choice.checked = selectedValues.includes(choice.value);
        });
    }

    getRequestEntries(): any[][] {
        if(this.value){
            return this.value.map((value) => {
                return [this.id, value];
            });
        } else {
            return [];
        }
    }
    
}